// for use in the getStaticData() test - src/lib/getStaticData.test.ts

export const test = {
  data: 'test',
};
